import React from 'react';
import ParentLayout from '@/pages/evaluations-project-educators-filtered/Layout';
import useRouter from '@/hooks/useRouter';
import useQuery from './useQuery';
import Evaluation from './Evaluation';
import useSchoolYearParams from '@/pages/evaluations/useSchoolYearParams';
import queryString from 'query-string';

export default function Layout(_props) {
  const { location } = useRouter();

  const params = useSchoolYearParams();

  const PAGE_SIZE = 12;

  const result = useQuery({
    location,
    search: queryString.parse(location.search),
    PAGE_SIZE,
    network: params.network,
    schoolStart: params.schoolStart,
    schoolEnd: params.schoolEnd
  });

  return (
    <ParentLayout
      location={location}
      extra={{
        schoolStart: params.schoolStart,
        schoolEnd: params.schoolEnd,
        variant: 'stories'
      }}
      breadcrumbs={['Evaluations', 'Projects: Educators']}
      title="Complete Evaluations"
      description={
      <span>
          This is a list of projects with an evaluation that was completed by the educator.
        </span>
      }
      pageSize={PAGE_SIZE}
      result={result}
      row={function (evaluationProjectEducator) {
        return (
          <Evaluation
            key={evaluationProjectEducator.id}
            evaluation={evaluationProjectEducator} />);


      }} />);


}